<template>
  <div class="services-page">
    <Breadcrumbs :links="breadCrumbsLinks"/>
    <div class="container">
      <div v-if="pending"
           class="container-inner">
        <div class="">
          <BasePreloader/>
        </div>
      </div>

      <div v-else-if="error" class="container-inner">
        <ErrorView :code="error.code"
                   :title="error.message"/>
      </div>

      <div v-else class="container-inner">
        <h1 class="services-page__title">
          {{ $tServices('Assistance for traveling and working abroad') }}
        </h1>
        <div class="services-page__services-list">
          <div v-for="(service, index) in services"
               :key="service.slug + index"
               :class="getClassByIndex(index)"
               class="services-page__services-item-wrap">
            <ServiceGroupCard :service="service"
                              :class="{'_odd': (index + 1) % 2}"
                              :trigger="trigger"
                              @open="trigger++"
                              class="services-page__services-item"/>
          </div>
        </div>
        <div v-if="faq || titleBody || textBody"
             class="services-page__info-section">
          <template v-if="faq">
            <h2 class="services-page__sub-title">{{ $tServices('Often asked') }}</h2>
            <AccordionInfo :items="faq"
                           class="services-page__faq"/>
          </template>
          <h2 v-if="titleBody"
              class="services-page__sub-title">{{ titleBody }}</h2>
          <div v-if="textBody"
               class="services-page__info-text  text" v-html="textBody">

          </div>
        </div>
        <HomePageReviews v-if="$get(reviews, 'data.length')" :reviews="reviews.data"/>
      </div>
    </div>
  </div>
</template>

<script>
  import globalMetaMixin from '@/mixins/globalMetaMixin'
  import Breadcrumbs from '@/components/Breadcrumbs';
  import ErrorView from '@/components/ErrorView'
  import ServiceGroupCard from '@/components/ServiceGroupCard'
  import AccordionInfo from '@/components/AccordionInfo'
  import {http} from '@/axios'
  import HomePageReviews from '@/components/homePage/HomePageReviews'

  export default {
    mixins: [globalMetaMixin],
    components: {
      HomePageReviews,
      Breadcrumbs,
      ErrorView,
      ServiceGroupCard,
      AccordionInfo,
    },
    data() {
      return {
        pending: false,
        error: null,
        title: null,
        services: null,
        faq: null,
        titleBody: null,
        textBody: null,
        trigger: 1,
        reviews: null
      }
    },
    computed: {
      breadCrumbsLinks() {
        const links = [{
          route: {name: 'services'},
          name: this.$tServices('Services')
        }, {
          name: this.title
        }]

        return links
      },
    },
    methods: {
      load() {
        this.pending = true

        http.get('/api/services ').then(({data}) => {
          this.title = data.data.meta_title
          // data.data.list[1].childs = data.data.list[1].childs.concat(data.data.list[0].childs)
          // data.data.list[1].childs = data.data.list[1].childs.concat(data.data.list[0].childs)
          this.services = data.data.list
          this.reviews = data.data.reviews
          // .concat(data.data.list[4]).concat(data.data.list[4])
          // this.services = this.services.slice(0, this.services.length - 1)
          this.faq = data.data.faq.map(item => {
            return {
              name: item.question,
              content: item.answer
            }
          })
          this.textBody = data.data.body
          this.titleBody = data.data.body_title

          this.setMetaTitleMixin(data.data.meta_title)
          this.setMetaDescriptionMixin(data.data.meta_description)
          this.setMetaKeywords(data.data.meta_keywords)

          this.setOpenGraph({
            title: data.data.meta_title,
            description: data.data.meta_description,
          })
        }).catch((error) => {
          this.error = {
            code: error.response.status,
            message: error.response.data && error.response.data.message || error.message
          }
        }).finally(() => {
          this.pending = false
        }).finally(() => {
          this.pending = false
        })
      },
      getClassByIndex(index) {
        let selector = ''

        if (this.services.length % 3) {
          if (!(this.services.length % 2) || index < this.services.length - 3) {
            selector += ' _wide'
          }
        }

        if (this.services.length % 2 && index === this.services.length - 1) {
          selector += ' _wide-sm'
        }

        // if (
        //     (this.services.length % 2 && index === this.services.length - 1)
        //     || index === this.services.length - 2
        // ) {
        //   selector += ' _last'
        // }

        return selector
      }
    },
    created() {
      this.load()
    },
    beforeDestroy() {
      this.deleteMetaKeywords()
    }
  }
</script>

<style lang="less">


</style>
